<p-progressBar
  [mode]="mode()"
  [value]="value()"
  [style]="{ height: size() }" />
